<div [innerHTML]="markAsTrusted ? (content | safe : 'html') : content"></div>
